// @flow

import React, { useEffect } from 'react';
import * as Sentry from '@sentry/browser';

import {
  commonErrors as Errors,
  selectErrorMessages,
} from '@zapier/toolbox-redux-framework';

import ErrorInfo from 'app/common/components/ErrorInfo';
import LearnMoreErrorInfo from 'app/common/components/LearnMoreErrorInfo';
import Modal from 'app/common/components/Modal';
import { isDataFlowProtectionRequired } from 'app/common/utils/ErrorUtils';

type ErrorModalProps = {
  onClose: () => void,
  errors: Array<Object>,
  isFromContactForm?: boolean,
};

const ErrorModal = ({
  onClose,
  errors,
  isFromContactForm,
}: ErrorModalProps) => {
  let error = errors[errors.length - 1];

  useEffect(() => {
    Sentry.captureException(new Error('ErrorModal rendered'), {
      tags: {
        section: 'devex',
      },
    });
  }, []);

  if (isDataFlowProtectionRequired(errors)) {
    Sentry.captureException(
      new Error(
        'The DestinationAuthModal would have been rendered, but it is no longer supported.'
      ),
      {
        tags: { section: 'devex' },
      }
    );
  }

  let ErrorType = error && error.name && Errors[error.name];

  if (!ErrorType) {
    error = new Errors.UnknownError(error);
    ErrorType = Errors.UnknownError;
  }

  const summary = ErrorType.summary(error);
  const errorsFound = ErrorType.errors(error);
  const messages = selectErrorMessages(errorsFound);

  const content = ErrorType.hasHelpLink(error) ? (
    <LearnMoreErrorInfo
      continueText="or continue to Dashboard"
      helpLink={ErrorType.helpLink(error)}
      onClose={onClose}
      summary={ErrorType.summary(error)}
      title="There's an Error With This Zap"
    />
  ) : (
    <ErrorInfo
      isFromContactForm={isFromContactForm}
      messages={messages}
      status={error.status}
      summary={summary}
    />
  );

  return (
    <Modal
      closeOnEsc={true}
      closeOnOutsideClick={true}
      isOpened={true}
      onClose={onClose}
    >
      {content}
    </Modal>
  );
};

export default ErrorModal;
